export default {"src":"/_next/static/media/pulse_icon_rgb_white.7dfc1015.svg","height":203,"width":203,"blurWidth":0,"blurHeight":0};